import { JsonLogicOperator } from '@jira/polaris__domain-field/src/jsonLogicOperator.constants.tsx';
import type { RulesLogic } from '@jira/polaris__domain-field/src/ValueDecoration.types.tsx';
import jsonLogic from '@jira/polaris__lib-json-logic/src/index.tsx';

const LABEL_LOGIC_PATTERN: RulesLogic = { [JsonLogicOperator.EQ]: ['@', { var: 'label' }] };

const isLabelLogic = (logic: RulesLogic): logic is RulesLogic => {
	return jsonLogic.rule_like(logic, LABEL_LOGIC_PATTERN);
};

/**
 * Special wrapper for applying option logic to handle apply for label and optionId fields
 * without a need to make a big refactoring or pass additional paramters by many methods.
 */
export const applyOptionLogic = (logic: RulesLogic, value: string | number): boolean => {
	const logicVarName = isLabelLogic(logic) ? 'label' : 'id';

	return jsonLogic.apply(logic, { [logicVarName]: value });
};

export const getOptionLogicValue = (logic: RulesLogic): string | number => {
	const [value] = jsonLogic.get_values(logic);

	return value;
};
